export const withHTTPProtocol = (host?: string) =>
  `${host?.includes('localhost') ? 'http' : 'https'}://${host}`;
export const withWSProtocol = (host?: string) =>
  `${host?.includes('localhost') ? 'ws' : 'wss'}://${host}`;

export const withoutQueryParams = (url: string) => {
  return url.split(/[?#]/)[0];
};
